var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.2222C13 17.0199 12.3533 17.6666 11.5556 17.6666H1.44445C0.646701 17.6666 0 17.0199 0 16.2222C0 15.4245 0.6467 14.7778 1.44445 14.7778H11.5556C12.3533 14.7778 13 15.4245 13 16.2222ZM26 8.99998C26 9.79772 25.3533 10.4444 24.5556 10.4444H1.44445C0.646701 10.4444 0 9.79772 0 8.99998C0 8.20223 0.6467 7.55553 1.44444 7.55553H24.5556C25.3533 7.55553 26 8.20223 26 8.99998ZM26 1.77776C26 2.5755 25.3533 3.2222 24.5556 3.2222H14.4444C13.6467 3.2222 13 2.5755 13 1.77776C13 0.980013 13.6467 0.333313 14.4444 0.333313H24.5556C25.3533 0.333313 26 0.980013 26 1.77776Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e1b1d47a5fe7328355e0231e904c5c69.svg";
export { ForwardRef as ReactComponent };